export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';
export const DYNAMIC_API_URL = import.meta.env.VITE_DYNAMIC_API_URL || 'http://localhost:9000';

